import { RouteHelpers } from '@/mixins';
import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';
import { Route } from 'vue-router';

const CabinetsDashboardComponent = () =>
  import(
    /* webpackChunkName: "CabinetConfiguration" */
    '@/components/configuration/cabinet/CabinetsDashboard.vue'
  );

const CabinetDashboardComponent = () =>
  import(
    /* webpackChunkName: "CabinetConfiguration" */
    '@/components/configuration/cabinet/CabinetDashboard.vue'
  );

const DocumentTypeDashboardComponent = () =>
  import(
    /* webpackChunkName: "CabinetConfiguration" */
    '@/components/configuration/cabinet/DocumentTypeDashboard.vue'
  );

const AddCabinetComponent = () =>
  import(
    /* webpackChunkName: "CabinetConfiguration" */
    '@/components/configuration/cabinet/AddCabinet.vue'
  );

const EditCabinetComponent = () =>
  import(
    /* webpackChunkName: "CabinetConfiguration" */
    '@/components/configuration/cabinet/EditCabinet.vue'
  );

const DeleteCabinetComponent = () =>
  import(
    /* webpackChunkName: "CabinetConfiguration" */
    '@/components/configuration/cabinet/DeleteCabinet.vue'
  );

const AddDocumentTypeComponent = () =>
  import(
    /* webpackChunkName: "CabinetConfiguration" */
    '@/components/configuration/cabinet/AddDocumentType.vue'
  );

const EditDocumentTypeComponent = () =>
  import(
    /* webpackChunkName: "CabinetConfiguration" */
    '@/components/configuration/cabinet/EditDocumentType.vue'
  );

const DeleteDocumentTypeComponent = () =>
  import(
    /* webpackChunkName: "CabinetConfiguration" */
    '@/components/configuration/cabinet/DeleteDocumentType.vue'
  );
const ConfigureRelatedDocumentLinksComponent = () =>
  import(
    /* webpackChunkName: "CabinetConfiguration" */
    '@/components/configuration/cabinet/ConfigureRelatedDocumentLinks.vue'
  );
const SecurityConfigurationComponent = () => import('@/views/configuration/cabinetConfiguration/SecurityConfiguration.vue');

const meta = {
  layout: 'TreeView',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'Cabinet Configuration'
};

export const CabinetConfigurationRoutes = [
  {
    ...Configuration.Cabinet.CabinetsDashboard,
    components: {
      default: CabinetsDashboardComponent,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.Cabinet.CabinetDashboard,
    components: {
      default: CabinetDashboardComponent,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.Cabinet.DocumentTypeDashboard,
    components: {
      default: DocumentTypeDashboardComponent,
      treeView: ConfigurationTreeView
    },
    meta,
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.Cabinet.CabinetsDashboard.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['documentTypeId']);
    }
  },
  {
    ...Configuration.Cabinet.AddCabinet,
    components: {
      default: AddCabinetComponent,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.Cabinet.EditCabinet,
    components: {
      default: EditCabinetComponent,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.Cabinet.DeleteCabinet,
    components: {
      default: DeleteCabinetComponent,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.Cabinet.AddDocumentType,
    components: {
      default: AddDocumentTypeComponent,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.Cabinet.EditDocumentType,
    components: {
      default: EditDocumentTypeComponent,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.Cabinet.DeleteDocumentType,
    components: {
      default: DeleteDocumentTypeComponent,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.Cabinet.ConfigureRelatedDocumentLinks,
    components: {
      default: ConfigureRelatedDocumentLinksComponent,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.Cabinet.GlobalCabinetSecurityConfiguration,
    components: {
      default: SecurityConfigurationComponent,
      treeView: ConfigurationTreeView
    },
    meta,
    props: { default: { entityTypeId: 110, entityPk: '' } }
  },
  {
    ...Configuration.Cabinet.CabinetSecurityConfiguration,
    components: {
      default: SecurityConfigurationComponent,
      treeView: ConfigurationTreeView
    },
    meta,
    props: { default: (route: Route) => ({ entityTypeId: 101, entityPk: route.params.cabinetId }) }
  },
  {
    ...Configuration.Cabinet.DocumentTypeSecurityConfiguration,
    components: {
      default: SecurityConfigurationComponent,
      treeView: ConfigurationTreeView
    },
    meta,
    props: { default: (route: Route) => ({ entityTypeId: 102, entityPk: route.params.documentTypeId.toString() }) }
  }
];
